import { render, staticRenderFns } from "./AbaGeralDoIrmao.vue?vue&type=template&id=4c896b7b"
import script from "./AbaGeralDoIrmao.vue?vue&type=script&setup=true&lang=ts"
export * from "./AbaGeralDoIrmao.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports